import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ajaxDeliveries from "../../util/remote/ajaxDeliveries";
const StationDeliveredFuelCards = () => {
  const company_id = Number(localStorage.getItem("FuelFy@company_id"));
  const getCurrentMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}`;
  };
  const [month, setMonth] = useState(getCurrentMonth());
  const [loading, setLoading] = useState(false);
  const [fuelData, setFuelData] = useState({});
  const fetchDeliveredFuel = async () => {
    setLoading(true);
    const response =
      await ajaxDeliveries.comapny_total_delivered_per_fuel_per_station({
        company_id,
        month,
      });
    if (response.status === "OK" && response.details) {
      setFuelData(response.details);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDeliveredFuel();
  }, [company_id, month]);
  const stationHeaderColor = "#4a90e2"; // same color for all stations
  const inputBgColor = "#f1f5f9"; // subtle background for month input
  return (
    <div className="container py-3">
      {/* Month Selector */}
      <div className="mb-4 d-flex justify-content-end">
        <input
          type="month"
          value={`${month.slice(0, 4)}-${month.slice(4, 6)}`}
          onChange={(e) => {
            const [yr, mn] = e.target.value.split("-");
            setMonth(`${yr}${mn}`);
          }}
          className="form-control"
          style={{
            width: "180px",
            backgroundColor: inputBgColor,
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "6px 12px",
          }}
        />
      </div>
      {/* Loading */}
      {loading && (
        <div className="text-center py-5">
          <p className="text-muted">Loading delivered fuel...</p>
        </div>
      )}
      {/* No Data */}
      {!loading && Object.keys(fuelData).length === 0 && (
        <div className="text-center py-5">
          <p className="text-muted">No deliveries found for this month.</p>
        </div>
      )}
      {/* Fuel Cards */}
      <div className="row g-3">
        {!loading &&
          Object.entries(fuelData).map(([station, fuels]) => (
            <div className="col-12" key={station}>
              <div
                className="p-3 shadow-sm rounded-3"
                style={{
                  backgroundColor: "#fff",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.03)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0,0,0,0.08)";
                }}
              >
                <div
                  className="mb-3 px-3 py-2 rounded-2 text-white fw-semibold"
                  style={{
                    backgroundColor: stationHeaderColor,
                    fontSize: "1rem",
                  }}
                >
                  {station}
                </div>
                <table className="table table-borderless mb-0">
                  <thead>
                    <tr>
                      <th className="text-muted small">Fuel Type</th>
                      <th className="text-end text-muted small">Delivered</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(fuels).map(([fuelName, quantity]) => (
                      <tr key={fuelName}>
                        <td>{fuelName}</td>
                        <td className="text-end">
                          {Number(quantity || 0).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
export default StationDeliveredFuelCards;
